module.exports = __webpack_public_path__ + "img/djzbpt.b63a1da5.png";